import { useEffect, useState } from 'react';
import {
  renderARElements,
  renderARImageTrackingMarker,
} from '../../../../helper/ar';
import { IConfig } from '../../../../interface/game';
import MarkerBasedSceneInit from './ImageTrackingSceneInitV2';
import { loadScript } from '../../../../util/script';
import { AframeListener } from '../js/aframeListener';
import ARCaptureBtn from '@/component/common/Button/ARCaptureBtn/ARCaptureBtn';
import MarkerBasedInstruction from './ImageTrackingInstruction';

const scripts = [
  {
    uri: 'https://aframe.io/releases/1.7.1/aframe.min.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
  {
    uri: 'https://s3.ap-south-1.amazonaws.com/vizaro.in/app/lib/mindar-image-aframe.prod-v2.js',
  },
];

type ImageTrackingContentProps = {
  config?: IConfig;
};

const ImageTrackingContent = ({ config }: ImageTrackingContentProps) => {
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const [markerThumbnail, setMarkerThumbnail] = useState<string | undefined>(
    undefined
  );
  const [targetSrc, setTargetSrc] = useState<string | undefined>(undefined);

  const renderMarker = (elements: any) => {
    const markerElement = elements.find((ele: any) => ele.type === 'MARKER');
    setTargetSrc(markerElement?.uri);
    if (markerElement) {
      renderARImageTrackingMarker();
      setMarkerThumbnail(markerElement?.thumbnail);
    }
  };
  const renderElements = () => {
    const elements = config?.elements || [];
    renderMarker(elements);
    renderARElements(elements);
  };

  const onLoadScripts = async () => {
    if (isScriptLoaded) return;
    for (const item of scripts) {
      await loadScript(item.uri);
    }
    setScriptLoaded(true);
  };
  const onSetTargetSrc = () => {
    const elements = config?.elements || [];
    const markerElement = elements.find((ele: any) => ele.type === 'MARKER');
    setTargetSrc(markerElement?.uri);
    setMarkerThumbnail(markerElement?.thumbnail);
  };
  useEffect(() => {
    onSetTargetSrc();
    onLoadScripts();
  }, []);
  useEffect(() => {
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        renderElements();
      } else if (scene) {
        scene.addEventListener('loaded', renderElements);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);
  if (!isScriptLoaded) return <div>Loading AR experience...</div>;
  return (
    <>
      <MarkerBasedSceneInit targetSrc={targetSrc} />
      <ARCaptureBtn videoId="ar-video" />
      {markerThumbnail && (
        <MarkerBasedInstruction markerThumbnail={markerThumbnail} />
      )}
    </>
  );
};

export default ImageTrackingContent;
